export default __webpack_public_path__ + "static/media/gallery_11.d8553664.jpg";